import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { useForm, FormProvider } from 'react-hook-form';
import moment, { Moment } from 'moment-timezone';
import { InputTimePicker } from '../../pickers';

const CustomEditTimePicker = (props: GridRenderEditCellParams & { name: string, placeholder: string }) => {
  const {
    id, field, value, minTime, name, placeholder, maxTime,
  } = props;

  const apiRef = useGridApiContext();

  const methods = useForm({
    mode: 'all',
    values: {
      [name]: value,
    },
  });

  const handleChange = (date: Moment | null) => {
    apiRef.current?.setEditCellValue({
      id,
      field,
      value: date,
    });
  };

  return (
    <FormProvider {...methods}>
      <InputTimePicker
        onChange={handleChange}
        defaultValue={value || moment()}
        placeholder={placeholder}
        minTime={minTime}
        maxTime={maxTime}
        name={name}
        size="medium"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
          },
          '& .MuiInputBase-input': {
            borderRadius: 0,
          },
        }}
      />
    </FormProvider>
  );
};

export {
  CustomEditTimePicker,
};
